module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-layout/gatsby-browser.js'),
      options: {"plugins":[],"component":"C:\\Users\\maja\\Documents\\code\\mebird\\dreamsmtree\\client\\src\\components\\layout\\Layout.tsx"},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"SMTree","short_name":"SMTree","start_url":"/","background_color":"#FF8800","theme_color":"#FF8800","theme_color_in_head":false,"icon":"src/images/tree.png","legacy":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"ce842d8102438f3364235778b1c454ee"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
